import { Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { trpc } from "@/lib/trpc";
import { useAuth } from "@/lib/auth";
import { recarregarNaOrganizacao } from "@/lib/recarregar-na-organizacao";

/** Saída do Começar: quem acabou de criar a organização (e mudou de ideia) não fica preso nele.
 *  O servidor só apaga se ela ainda estiver vazia; senão explica o caminho da exclusão normal. */
export function CancelarCriacao() {
  const { user } = useAuth();
  const org = user?.activeOrganization;
  const cancelar = trpc.organization.exclusao.cancelarCriacao.useMutation({
    onSuccess: () => {
      toast.success(`${org?.name ?? "A organização"} foi descartada.`);
      recarregarNaOrganizacao(null, "/inicio");
    },
    onError: (e) => toast.error(e.message || "Não foi possível cancelar a criação."),
  });
  if (!org || org.isPersonal || org.role !== "OWNER") return null;

  const confirmar = () => {
    if (window.confirm(`Descartar ${org.name}? A organização é apagada e você volta para a anterior.`)) cancelar.mutate();
  };

  return (
    <div className="mb-3 flex justify-end">
      <button
        type="button"
        onClick={confirmar}
        disabled={cancelar.isPending}
        className="inline-flex h-9 items-center gap-1.5 rounded-md px-3 text-sm font-medium text-zinc-500 transition-colors hover:bg-zinc-100 hover:text-red-600 disabled:opacity-50 dark:text-muted-foreground dark:hover:bg-muted"
      >
        {cancelar.isPending ? <Loader2 className="h-4 w-4 animate-spin" /> : <X className="h-4 w-4" />}
        Cancelar criação
      </button>
    </div>
  );
}
